import { render } from "./DriverDashboardCleanupNotification.vue?vue&type=template&id=a1a8a8a6&lang=true"
import script from "./DriverDashboardCleanupNotification.vue?vue&type=script&lang=js"
export * from "./DriverDashboardCleanupNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__